const constants = {
  locale: {
    en: "en",
    ch: "ch",
  },
  formType: {
    new: "N",
    renew: "R"
  },
  appTypeMapping: {
    "N": 1,
    "R": 2,
    "C": 3
  },
  fileCategory: [
    "ApplicantPhoto",
    "OctopusFront",
    "OctopusBack",
    "AirportWorkerProof"
  ],
  links: {
    personal: {
      faq: "https://www.mtr.com.hk/archive/ch/tickets/airport_scheme_online_application_faq.pdf"
    },
    company: {
      faq: "https://www.mtr.com.hk/archive/ch/tickets/airport_scheme_company_management_portal_faq.pdf",
      tutorial: {
        en: "https://www.mtr.com.hk/archive/ch/tickets/airport_scheme_company_portal_tutorials_en.pdf",
        ch: "https://www.mtr.com.hk/archive/ch/tickets/airport_scheme_company_portal_tutorials_ch.pdf"
      },
      form: {
        registration: "https://www.mtr.com.hk/archive/ch/tickets/airport_scheme_company_registration_form.pdf"
      }
    },
    common: {
      maintenance: "https://www.mtr.com.hk/maintenance_airport_staff_travel_scheme.html"
    }
  },
  unit: {
    character: ["character", "characters"],
    digit: ["digit", "digits"],
    year: ["year old", "years old"],
    month: ["month", "months"],
    entry: ["entry", "entries"]
  },
  uploadType: {
    image: "I",
    pdf: "P"
  },
  dataType: {
    file: "File",
    base64: "base64"
  },
  errMsg: {
    renewalEditOctopusDuplicate: {
      en: "The Octopus card number you provided is the same as the current record. Please check.",
      ch: "你所提供的八達通卡號碼與當前記錄相同，請檢查。"
    }
  },
  expiryEnquiry: {
    identifier: {
      "0": "identityNum",
      "1": "cardNum"
    }
  },
  octopusLanding: {
    activate: "mxpa",
    renewal: "mxpr",
    error: "error"
  },
  sortingProps: {
    appEnquiry: {
      createdDate: 0,
      expiryDate: 1,
      applicationId: 2,
      name: 3 
    },
    resignList: {
      applyDate: 0,
      revokeDate: 1,
      staffName: 2,
      identityNumber: 3 
    }
  },
  sortingOrder: {
    ascending: 0,
    descending: 1
  }
};

export default constants;
